import { memo } from 'react';

import { ArrowLeftToLineIcon } from '@air/design-icons';
import { IconButton, type IconButtonProps } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

export type AssetModalLeftPanelCloseButtonProps = {
  'data-testid': string;
  label: string;
  onClick: () => void;
  size: IconButtonProps['size'];
  tooltipLabel: string;
};

export const AssetModalLeftPanelCloseButton = memo(
  ({ 'data-testid': dataTestId, label, onClick, size, tooltipLabel }: AssetModalLeftPanelCloseButtonProps) => {
    return (
      <Tooltip label={tooltipLabel}>
        <IconButton
          adsIcon
          appearance="ghost"
          color="gray"
          data-testid={dataTestId}
          label={label}
          size={size}
          onClick={onClick}
          icon={ArrowLeftToLineIcon}
        />
      </Tooltip>
    );
  },
);

AssetModalLeftPanelCloseButton.displayName = 'AssetModalLeftPanelCloseButton';
